"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const Banners_1 = require("../Banners");
const utils_1 = require("../../lib/utils");
const configUtils_1 = require("../../lib/configUtils");
const States_1 = require("../../lib/constants/States");
const EpicOSW_1 = require("../../lib/constants/EpicOSW");
const propTypes_1 = require("../../lib/propTypes");
function OSWApptInfo({ service, config }) {
    const [state] = (0, react_2.useService)(service);
    const { provider, epicOSWConfig, externalID, visitType } = state.context;
    /**
     * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
     */
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    if (state.matches(States_1.error)) {
        return (react_1.default.createElement("div", { "data-testid": "OSWApptInfo" },
            react_1.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone })));
    }
    if (state.matches(States_1.success)) {
        const iFrameURL = epicOSWConfig.open_scheduling_host;
        const iFrameURLParams = `?id=${externalID}&vt=${visitType}`;
        return (react_1.default.createElement("div", { "data-testid": "OSWApptInfo" },
            react_1.default.createElement("link", { href: epicOSWConfig.open_scheduling_css_url, rel: "stylesheet", type: "text/css" }),
            react_1.default.createElement("div", { id: "scheduleContainer" },
                react_1.default.createElement("iframe", { title: EpicOSW_1.IFRAME_TITLE, id: "openSchedulingFrame", className: "widgetframe", scrolling: "no", src: `${iFrameURL}${iFrameURLParams}`, "data-oswstep": "0", onLoad: () => {
                        window.EWC = new window.EmbeddedWidgetController({
                            hostname: epicOSWConfig.open_scheduling_hostname,
                            // Must equal media query in EpicWP.css + any left/right margin of the host page.
                            // Should also change in EmbeddedWidget.css
                            matchMediaString: '(max-width: 747px)',
                            //Show a button on top of the widget that lets the user see the slots in fullscreen.
                            showToggleBtn: true
                        });
                    } }))));
    }
    return null;
}
exports.default = OSWApptInfo;
const propTypes = {
    /**
     * The machine that maintains state and context for the component
     */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    config: propTypes_1.configType
};
OSWApptInfo.propTypes = propTypes;
OSWApptInfo.defaultProps = {
    config: {}
};
//# sourceMappingURL=OSWApptInfo.js.map